import { render, staticRenderFns } from "./ItsBaseConsignAddress.vue?vue&type=template&id=42ee0f09&scoped=true&"
import script from "./ItsBaseConsignAddress.vue?vue&type=script&lang=js&"
export * from "./ItsBaseConsignAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ee0f09",
  null
  
)

export default component.exports